import React, { FC } from 'react'
import { IconButton } from 'transfix-ui/components/IconButton'
import Box from 'transfix-ui/core/Box'
import { makeStyles } from 'transfix-ui/core/styles'
import { brandColors } from 'transfix-ui/theme'
import { EditIcon } from 'transfix-icons'

const useStyles = makeStyles(theme => ({
  editableField: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  editIcon: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    color: brandColors.info,
  },
  fieldName: {
    fontSize: '0.8rem',
    fontWeight: 700,
    color: brandColors.coolGray5,
  },
}))

interface IEditableFieldProps {
  fieldName: string
  fieldValue: string
  onEditClick: () => void
  readOnly?: boolean
}

export const EditableField: FC<IEditableFieldProps> = ({
  fieldName,
  fieldValue,
  onEditClick,
  readOnly = false,
}) => {
  const classes = useStyles()

  return (
    <Box className={classes.editableField}>
      <Box display='flex' flexDirection='column'>
        <Box className={classes.fieldName}>{fieldName}</Box>
        <Box>{fieldValue}</Box>
      </Box>
      <Box className={classes.editIcon}>
        <IconButton
          Icon={EditIcon}
          color='tertiary'
          onClick={onEditClick}
          disabled={readOnly}
          size='large'
        />
      </Box>
    </Box>
  )
}
